import { ExpertRole } from "@/features/experts/types/ExpertRole";
import { VenereChatSession } from "../types/VenereChatSession";

// Get role display string
export const getRoleDisplayString = (role: ExpertRole): string => {
  switch (role) {
    case ExpertRole.Nutritionist:
      return 'Nutrizionista';
    case ExpertRole.Physician:
      return 'Endocrinologo';
    case ExpertRole.Psychologist:
      return 'Psicologo';
    case ExpertRole.Admin:
      return 'Customer Care';
    default:
      return role;
  }
};

// Determine box variant based on session existence
export const getBoxVariant = (expertSession: VenereChatSession | null): "lavender" | "seasalt" => {
  if (expertSession) {
    return "lavender"; // Existing session - purple/lavender
  }
  return "seasalt"; // No session - default seasalt
};

// Get status text and color
export const getStatusInfo = (expertSession: VenereChatSession | null) => {
  if (expertSession) {
    return {
      text: "Chat già attiva",
      color: "text-venere-royal",
      bgColor: "bg-venere-lavender"
    };
  }
  return {
    text: "Crea nuova chat",
    color: "text-venere-slate",
    bgColor: "bg-venere-seasalt"
  };
}; 